import { useContext } from 'react'

import { ChangeScheduleFiltersContext } from './context'

export function useChangeScheduleFiltersContext<T extends boolean = true>(throwError: T = true as T) {
  const context = useContext(ChangeScheduleFiltersContext)
  if (context === undefined && throwError) {
    throw new Error('useChangeFiltersContext must be used within a ChangeFiltersProvider')
  }
  return context as T extends true ? NonNullable<typeof context> : typeof context
}
